<template lang="">
    <div style="margin-bottom: 20px;">
        <div class="d-flex mb-2">
            <div v-if="prices.list" class="mr-5" style="font-size: 14px; color: #000;">
                定價: <span :style="lineThrough">{{ prices.list | currency }}</span>
            </div>
            <div v-if="prices.suggest" style="font-size: 14px; color: #000;">
                建議售價: <span :style="lineThrough">{{ prices.suggest | currency }}</span>
            </div>
        </div>
        <div v-if="prices.retail" style="font-size:28px;font-weight:300;margin-right:6px">{{ prices.retail | currency }}</div>
    </div>

</template>
<script>
    export default {
        props: {
            prices: {
                default() {
                    return {};
                }
            }
        },
        mounted() {
        },
        computed: {
            lineThrough() {
                return {
                    "text-decoration": "line-through"
                };
            }
        },
        filters: {
            currency(input) {
                return `NT$ ${input}`;
            }
        }
    }
</script>
<style lang="">

</style>